module.exports = __webpack_public_path__ + "img/camera-angle1.ee69fae1.png";